export const Update = data => ({
	type: 'UPDATE',
	data,
});

export const CheckOut = () => ({
	type: 'CHECKOUT',
	data: {},
});
